module.exports = __webpack_public_path__ + "static/media/Searchengines-rafiki.a86f9527.png";